export default __webpack_public_path__ + "static/media/Macrobac-500-Tab-ban.20887d9b.jpg";